export const TYPE_GROUPS = {
  string: "string",
  number: "number",
  date: "date",
  boolean: "boolean",
  media: "media",
};

export const buckets = {
  string: TYPE_GROUPS.string,
  text: TYPE_GROUPS.string,
  number: TYPE_GROUPS.number,
  bigint: TYPE_GROUPS.number,
  decimal: TYPE_GROUPS.number,
  float: TYPE_GROUPS.number,
  integer: TYPE_GROUPS.number,
  currency: TYPE_GROUPS.number,
  date: TYPE_GROUPS.date,
  datetime: TYPE_GROUPS.date,
  boolean: TYPE_GROUPS.boolean,
};

export function dataTypeAlignment(type) {
  const bucket = buckets[type];
  return bucket === "number" ? "right" : "left";
}

const aggregationColors = {
  number: "#52d2d6",
  date: "#52d696",
};

const numberAggregations = new Set([
  "MAX",
  "AVG",
  "COUNT",
  "MIN",
  "DISTINCT COUNT",
  "SUM",
  "1",
  "2",
  "3",
  "4",
  "5",
  "11",
]);

const dateAggregations = new Set([
  "YEAR",
  "QUARTER",
  "MONTH",
  "WEEK",
  "DAY",
  "6",
  "7",
  "8",
  "9",
  "10",
]);

export function getAggregationTypeBackground(aggregation) {
  if (numberAggregations.has(aggregation + "")) return aggregationColors.number;
  if (dateAggregations.has(aggregation + "")) return aggregationColors.date;
  return null;
}

export const mappingTypes = {
  string: { lib: "fas", icon: "text-size", parameter: true },
  currency: { lib: "far", icon: "dollar-sign" },
  "currency-whole": { lib: "fal", icon: "dollar-sign" },
  decimal: { lib: "fas", icon: "calculator-alt" },
  percent: { lib: "fas", icon: "percent" },
  date: { lib: "fas", icon: "calendar-week", parameter: true },
  datetime: { lib: "fas", icon: "calendar-week" },
  integer: { lib: "far", icon: "list-ol" },
  boolean: { lib: "fas", icon: "toggle-on" },
  "api-image": { lib: "fal", icon: "image" },
  "MMM yyyy": { lib: "fas", icon: "calendar-day" },
  "'Q'Q yyyy": { lib: "fas", icon: "calendar-star" },
  yyyy: { lib: "fas", icon: "calendar-alt" },
};

export const typeNames = [
  "string",
  "currency",
  "currency-whole",
  "decimal",
  "percent",
  "date",
  "integer",
];

export const allowed = {
  [TYPE_GROUPS.string]: ["string"],
  [TYPE_GROUPS.number]: ["string", "currency", "decimal", "percent", "integer"],
  [TYPE_GROUPS.date]: ["string", "date"],
  [TYPE_GROUPS.media]: ["api-image"],
};
